import { MacOSIcon, WindowsIcon } from 'components/Icons/PlatformIcons';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import cls from 'classnames';

import styles from './GameCard.module.scss';

import { PlayIcon } from 'components/Icons/Icons';

export type GameCardProps = {
  poster: string;
  mobilePoster: string;
  title: string;
  description: string;
  playLink: string;
  macos: boolean;
  className?: string;
};

export const GameCard = (props: GameCardProps) => {
  return (
    <div className={cls(props.className, styles.gameCard)}>
      <LazyLoadImage className={styles.poster} src={props.poster} />
      <LazyLoadImage className={styles.mobilePoster} src={props.mobilePoster} />
      <div className={styles.gameDescription}>
        <div>
          <h3 className="subheading-large">{props.title}</h3>
          <p className="body-default text-60">{props.description}</p>
        </div>
        <div className={styles.gamePlatforms}>
          <div className={styles.platformIcon}>
            <WindowsIcon stroke={styles.platformIconColor} />
            {props.macos && <MacOSIcon stroke={styles.platformIconColor} />}
            Windows {props.macos && '& MacOS'}
          </div>
          <Link to={props.playLink}>
            <button className="btn btn-sm btn-primary">
              <div className={styles.buttonContent}>
                <PlayIcon />
                <span>Play</span>
              </div>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};
